import React from 'react';
import './CountComponent.scss';
function CountSelectedComponent(props) {
  const { total } = props;

  return (
    <label className="count-text">
      You have selected ({total || 0}) transactionss
    </label>
  );
}

export default CountSelectedComponent;
